/* eslint-disable prefer-promise-reject-errors */

/* eslint-disable no-unused-vars */

/* eslint-disable no-unused-expressions */

/* eslint-disable func-names */

/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_CUSTOMER_URL, API_MEDIA_URL, COMMON_HEADER_CONFIG} from "../config";

class CustomerService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchCustomers = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CUSTOMER_URL}/filter-customer?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 100,
          page: 1,
          ...data
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  searchValidCustomer = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CUSTOMER_URL}/filter-customer/check-valid`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {...data}
      };
      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  searchCustomersByOrderNumber = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CUSTOMER_URL}/filter-customer/get-customer-by-order-number?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {...data}
      };
      return axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListCustomer = (data) =>
    new Promise((resolve, reject) => {
      const params = {
        size: 100,
        page: 1
      };
      if ("phone_number" in data) {
        params.phone_number = data.phone_number;
      }
      const config = {
        method: "get",
        url: `${API_CUSTOMER_URL}/filter-customer?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  // create customer
  createCustomer = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_CUSTOMER_URL}/customer`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneCustomer = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CUSTOMER_URL}/customer/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateCustomer = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_CUSTOMER_URL}/customer/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  uploadImage = (presignedPostData, file) =>
    new Promise((resolve, reject) => {
      const formData = new FormData();
      Object.keys(presignedPostData.fields).forEach((key) => {
        formData.append(key, presignedPostData.fields[key]);
      });

      // Actual file has to be appended last.
      formData.append("file", file);

      const xhr = new XMLHttpRequest();
      xhr.open("POST", presignedPostData.url, true);
      xhr.send(formData);
      xhr.onload = function (response) {
        this.status === 204 ? resolve("success") : reject(null);
      };
    });

  preUpload = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_MEDIA_URL}/uploads/pre_up`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createUpload = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_MEDIA_URL}/uploads/create`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteOneCustomer = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_CUSTOMER_URL}/customer/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        }
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteBulkCustomer = (listCustomer) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_CUSTOMER_URL}/customer`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: listCustomer
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListMetaData = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CUSTOMER_URL}/metadata?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          platform_key: "centralweb",
          type: "customer_group"
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const customerService = new CustomerService();

export default customerService;
